import { render, staticRenderFns } from "./VlPoiItem.vue?vue&type=template&id=e7b322a2&"
import script from "./VlPoiItem.vue?vue&type=script&lang=js&"
export * from "./VlPoiItem.vue?vue&type=script&lang=js&"
import style0 from "./VlPoiItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports